import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1.5rem;
`;

export const InlineForm = styled.div`
  display: flex;
  gap: 1rem;

  div {
    width: 100%;
  }
`;
export const Alert = styled.div`
  width: 100%;
  margin-top: 1rem;
  svg {
    width: 1.75rem !important;
    height: 1.75rem !important;
  }
`;
